export default __webpack_public_path__ + "static/media/question_mark_circle.70ab802c.svg";